(function (Drupal) {

  Drupal.behaviors.countUpNumbers = {
    attach: function (context) {

      const elements = context.querySelectorAll('.countup-number');

      const observer = new IntersectionObserver(entries => {

        entries.forEach(entry => {

          if (entry.isIntersecting) {
            animateNumber(entry.target);
          }

        });

      }, { threshold: 0.6 });

      elements.forEach(el => {
        observer.observe(el);
      });

      function shortNumber(num) {

        const abs = Math.abs(num);
        let formatted;
        let suffix = '';

        if (abs >= 1000000000) {
          formatted = num / 1000000000;
          suffix = 'B';
        }
        else if (abs >= 1000000) {
          formatted = num / 1000000;
          suffix = 'M';
        }
        else if (abs >= 1000) {
          formatted = num / 1000;
          suffix = 'K';
        }
        else {
          return Math.floor(num);
        }

        if (formatted % 1 === 0) {
          return Math.floor(formatted) + suffix;
        }

        return formatted.toFixed(1) + suffix;
      }

      function animateNumber(el) {

        const target = parseInt(el.dataset.countTarget);
        let start = 0;

        const duration = 1200;
        const stepTime = 16;
        const steps = duration / stepTime;
        const increment = target / steps;

        function animate() {

          start += increment;

          if (start < target) {
            el.childNodes[0].nodeValue = shortNumber(start);
            requestAnimationFrame(animate);
          } else {
            el.childNodes[0].nodeValue = shortNumber(target);
          }

        }

        animate();

      }

    }
  };

})(Drupal);